(() => {
  function initialise(root) {
    root.querySelectorAll('[data-article-chart]').forEach((chart) => {
      const table = chart.querySelector('[data-chart-table]');
      if (!table || chart.dataset.chartReady) return;
      chart.dataset.chartReady = 'true';
      const body = table.tBodies[0];
      const rows = Array.from(body.rows);
      const search = chart.querySelector('[data-chart-search]');
      const previous = chart.querySelector('[data-chart-previous]');
      const next = chart.querySelector('[data-chart-next]');
      const status = chart.querySelector('[data-chart-status]');
      const headers = Array.from(table.tHead.rows[0].cells);
      const collator = new Intl.Collator(document.documentElement.lang || undefined, { numeric: true, sensitivity: 'base' });
      const searchable = new Map(rows.map((row) => [row, Array.from(row.cells, (cell) => cell.textContent).join(' ').toLocaleLowerCase()]));
      const pageSize = 20;
      let page = 0;
      let column = -1;
      let ascending = true;
      function update() {
        const term = search.value.trim().toLocaleLowerCase();
        const matches = rows.filter((row) => searchable.get(row).includes(term));
        if (column >= 0) {
          matches.sort((a, b) => {
            const left = a.cells[column].textContent.trim();
            const right = b.cells[column].textContent.trim();
            const numeric = left !== '' && right !== '' && Number.isFinite(Number(left)) && Number.isFinite(Number(right));
            return (numeric ? Number(left) - Number(right) : collator.compare(left, right)) * (ascending ? 1 : -1);
          });
        }
        page = Math.min(page, Math.max(0, Math.ceil(matches.length / pageSize) - 1));
        rows.forEach((row) => { row.hidden = true; });
        const start = page * pageSize;
        matches.slice(start, start + pageSize).forEach((row) => { row.hidden = false; body.append(row); });
        status.textContent = matches.length
          ? status.dataset.resultsTemplate.replace('[start]', start + 1).replace('[end]', Math.min(start + pageSize, matches.length)).replace('[total]', matches.length)
          : status.dataset.emptyLabel;
        previous.disabled = page === 0;
        next.disabled = start + pageSize >= matches.length;
      }
      headers.forEach((header, index) => {
        const label = header.querySelector('[data-chart-heading]');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'article-chart__sort';
        button.textContent = label.textContent;
        label.replaceWith(button);
        button.addEventListener('click', () => {
          ascending = column === index ? !ascending : true;
          column = index;
          page = 0;
          headers.forEach((item) => item.removeAttribute('aria-sort'));
          header.setAttribute('aria-sort', ascending ? 'ascending' : 'descending');
          update();
        });
      });
      search.addEventListener('input', () => { page = 0; update(); });
      previous.addEventListener('click', () => { page -= 1; update(); });
      next.addEventListener('click', () => { page += 1; update(); });
      chart.querySelectorAll('[data-chart-controls]').forEach((control) => { control.hidden = false; });
      update();
    });
  }
  function start() {
    const initialHash = location.hash;
    const hasTable = document.querySelector('[data-chart-table]');
    initialise(document);
    if (!initialHash || !hasTable) return;
    const alignInitialTarget = () => requestAnimationFrame(() => {
      if (location.hash !== initialHash) return;
      let id;
      try { id = decodeURIComponent(initialHash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (target?.closest('#main-content')) target.scrollIntoView({ behavior: 'instant' });
    });
    if (document.readyState === 'complete') alignInitialTarget();
    else window.addEventListener('load', alignInitialTarget, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

// Shopify returns successful article contact submissions with this status flag.
(() => {
  const showConfirmation = () => {
    const message = document.getElementById('AIShoppingAuditSuccess');
    if (!message || new URLSearchParams(location.search).get('contact_posted') !== 'true') return;
    message.hidden = false;
    const focusConfirmation = () => requestAnimationFrame(() => {
      message.focus({ preventScroll: true });
      message.scrollIntoView({ block: 'center' });
    });
    if (document.readyState === 'complete') focusConfirmation();
    else window.addEventListener('load', focusConfirmation, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showConfirmation);
  else showConfirmation();
})();
